<template>
  <div>
    <div class="tab">
      <div class="tab__header">
        <div class="tab__header-select">
          <select v-model="currentCollectionId" :disabled="isLoading.collections" class="form-control select">
            <option
              v-for="collection of collections"
              :key="collection.id"
              :value="collection.id"
            >{{ collection.name }}</option>
          </select>
        </div>
        <div class="tab__title h2">Вопросы по темам</div>
      </div>

      <loader v-if="isLoading.themes"></loader>
      <div v-else class="tab__content">
        <router-link
          v-for="theme of themes"
          :to="{ path:`/pdd/themes/${theme.id}`, query: { coll: currentCollectionId } }"
          :key="theme.id"
          class="question"
          :class="{ ' question-passed': getThemeResult(theme.id) }"
        >
          <div class="question__content">
            <div class="question__title">{{ theme.name }}</div>
            <div class="question__number">Вопросов: {{ theme.questions_count }}</div>

            <div v-if="getThemeResult(theme.id)" class="question__status">
              <div class="correct">{{ getThemeResult(theme.id).right }}</div>
              <div class="error">{{ getThemeResult(theme.id).wrong }}</div>
            </div>
            <div v-else  class="ticket__status">Не выполнен</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Tickets',
    data() {
      return {
        currentCollectionId: null,
      };
    },
    computed: {
      collections() {
        return this.$store.getters.collections;
      },
      themes() {
        return this.$store.getters.themes;
      },
      isLoading() {
        return this.$store.getters.collectionsLoaders;
      },
    },
    methods: {
      loadCollectionThemes(id) {
        this.$store.dispatch('getCollectionThemes', id);
      },
      getThemeResult(themeId) {
        const { themeResults } = this.$appSettings;
        let ticketInfo = null;

        for (const theme of themeResults) {
          if (theme.themeId === parseInt(themeId, 10) && theme.collectionId === parseInt(this.currentCollectionId, 10)) {
            ticketInfo = theme;
            break;
          }
        }

        return ticketInfo;
      },
    },
    created() {
      this.$store.dispatch('getCollections')
        .then(() => {
          if (!this.$route.query.coll) {
            if (!localStorage.getItem('theme_id')) {
              this.currentCollectionId = this.collections[0].id;
            } else {
              this.currentCollectionId = localStorage.getItem('theme_id');
            }
          } else {
            this.currentCollectionId = this.$route.query.coll;
          }
        });
    },
    watch: {
      currentCollectionId(id) {
        this.loadCollectionThemes(id);
        localStorage.setItem('theme_id', id);
      },
    },
  };
</script>
